
import { mapState, mapMutations, mapActions } from 'vuex'

import FormField from '../../_globals/forms/FormField.vue'
import Icon from '../Icon'

export default {
  name: 'LocationCurbsideForm',
  components: { FormField, Icon },
  props: {
    action: Object,
  },
  data() {
    return {
      isEdit: true,
      makeField: {
        name: 'make',
        label: '',
        type: 'text',
        value: '',
        placeholder: 'Make',
        valid: /^[A-Za-z0-9]{20}/,
        errors: {
          invalid: 'Please enter a valid make.'
        }
      },
      modelField: {
        name: 'city',
        label: '',
        type: 'text',
        value: '',
        placeholder: 'Model',
        valid: /^[A-Za-z0-9]{20}/,
        errors: {
          invalid: 'Please enter a valid model.'
        }
      },
      colorField: {
        name: 'state',
        label: '',
        type: 'text',
        value: '',
        placeholder: 'Color',
        valid: /^[A-Za-z0-9]{20}/,
        errors: {
          invalid: 'Please enter a valid color.'
        }
      },
    }
  },
  mounted() {
    if (this.cart && this.cart.custom) {
      const makeObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'make')
      const make = makeObj ? makeObj.value : ''
      const modelObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'model')
      const model = modelObj ? modelObj.value : ''
      const colorObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'color')
      const color = colorObj ? colorObj.value : ''
      
      if (make && model && color) {
        return this.updateForm({ make, model, color })
      }
    }

    if (this.vehicleInfo) {
      return this.updateForm(this.vehicleInfo)
    }

    this.isEdit = true
  },
  computed: {
    ...mapState([ 'loading', 'cart' ]),
    ...mapState({
      vehicleInfo: state => state.locations.vehicleInfo
    }),
    orderCurbsideDisabled() {
      if (this.loading) return true

      if (!this.makeField.value ||
          !this.modelField.value ||
          !this.colorField.value
        ) return true

      return false
    },
  },
  methods: {
    ...mapActions([ 'getCart' ]),
    ...mapActions({
      applyCartHandoff: 'checkout/applyCartHandoff',
    }),
    ...mapMutations({
      setVehicleInfo: 'locations/setVehicleInfo',
    }),
    edit() {
      this.isEdit = !this.isEdit
    },
    async handleSubmit() {
      this.isEdit = false
      this.setVehicleInfo({
        make: this.makeField.value,
        model: this.modelField.value,
        color: this.colorField.value,
      })

      await this.applyCartHandoff({
        Make: this.makeField.value,
        Model: this.modelField.value,
        Color: this.colorField.value,
        handoffMode: 'curbside',
      })

      await this.getCart()
    },
    updateForm({ make, model, color }) {
      this.makeField.value = make
      this.modelField.value = model
      this.colorField.value = color

      this.setVehicleInfo({ make, model, color })

      this.isEdit = false
    },
  },
}
